import { render, staticRenderFns } from "./DissolveIcon.vue?vue&type=template&id=46f92bd2&"
import script from "./DissolveIcon.vue?vue&type=script&lang=js&"
export * from "./DissolveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports